import * as React from "react";
import type { SVGProps } from "react";
const SvgCumulativeincomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="cumulativeincome_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M746.667 85.333a42.667 42.667 0 1 0 0 85.334h46.336l-128 128h-323.67a42.667 42.667 0 0 0-24.448 7.68L103.552 455.68a42.667 42.667 0 1 0 48.939 69.973L354.773 384h327.894a42.667 42.667 0 0 0 30.165-12.501l213.333-213.334A42.667 42.667 0 0 0 896 85.333H746.667zm149.333 256A42.667 42.667 0 0 1 938.667 384v512a42.667 42.667 0 1 1-85.334 0V384A42.667 42.667 0 0 1 896 341.333zM682.667 512a42.667 42.667 0 1 0-85.334 0v384a42.667 42.667 0 1 0 85.334 0V512zM384 554.667a42.667 42.667 0 0 1 42.667 42.666V896a42.667 42.667 0 1 1-85.334 0V597.333A42.667 42.667 0 0 1 384 554.667zM128 640a42.667 42.667 0 0 1 42.667 42.667V896a42.667 42.667 0 1 1-85.334 0V682.667A42.667 42.667 0 0 1 128 640z"
    />
  </svg>
);
export default SvgCumulativeincomeIcon;
